import React from "react";
import { Loader } from "../../../components/Loader/Loader";
import FindingsPanel from "./FindingsPanel";
import AnalysisPanel from "./AnalysisPanel";
import "../../../styles/pages/AdhocInvestigation/WGEDRPanel.scss";

const WGEDRPanel = ({ data, loading, error, setCommentModalData, traceID }) => {
  if (loading) return <Loader />;
  if (error) return <div className="error-message">{error}</div>;
  if (!data) return null;

  return (
    <div className="wgedr-panel-container">
      <FindingsPanel 
        data={data} 
        setCommentModalData={setCommentModalData} 
        traceID={traceID} 
      />
      <AnalysisPanel 
        data={data} 
        loading={loading} 
        setCommentModalData={setCommentModalData} 
        traceID={traceID} 
      />
    </div>
  );
};

export default WGEDRPanel; 